<template>
  <v-dialog v-model="visible" max-width="550" persistent>
    <v-card>
      <v-card-title class="text-h6"> {{ `Lägg till ny ${sectionLabel}` }} </v-card-title>

      <v-card-text>
        <v-text-field
          label="Rapportens titel"
          clearable
          hide-details="true"
          outlined
          v-model="title"
        ></v-text-field>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn text :to="{ name: 'ReportsList', params: { section } }"> Avbryt </v-btn>

        <v-btn color="primary" :disabled="!title" :loading="loading" @click="save"> Spara </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex'
// eslint-disable-next-line no-unused-vars
import sectionUrls, { sections } from '@/assets/data/reportTypes'

export default {
  name: 'ReportCreate',
  data() {
    return {
      visible: true,
      title: '',
      loading: false,
    }
  },
  computed: {
    section() {
      return this.$route.params.section
    },
    sectionLabel() {
      return sections.find((s) => s.name === sectionUrls[this.section]).singelLabel
    },
  },
  methods: {
    ...mapActions('reports', { createReport: 'create' }),
    ...mapActions('content', { createContent: 'create' }),

    async save() {
      this.loading = true
      const payload = {
        article_title: this.title,
        article_status: 'offline',
        article_type: sectionUrls[this.section],
      }
      const { id } = await this.createReport(payload)
      await this.createContent({ type: 'report', parent_id: id, data: `<p>${this.title}</p>` })

      this.loading = false
      this.$router.replace({ name: 'SingleReport', params: { id, seciton: this.section } })
    },
  },
}
</script>

<style lang="scss" scoped></style>
